export const TRACK_PAGE_DIMENSIONS = {
  WIDTH: 775,
  HEIGHT: 630,
};

export const DEFAULT_VERTICAL_WIDTH = 350;
export const LAYOUTS_VERTICAL = 0;
export const LAYOUTS_HORIZONTAL = 1;
export const LAYOUTS_LIST = 2;

export const LAYOUT_DEFAULTS: Record<number, {defaultNumberTracksShown: number; defaultWidth?: number}> = {
  [LAYOUTS_VERTICAL]: {
    defaultNumberTracksShown: 3,
  },
  [LAYOUTS_HORIZONTAL]: {
    defaultNumberTracksShown: 3,
  },
  [LAYOUTS_LIST]: {
    defaultWidth: 680,
    defaultNumberTracksShown: 4,
  },
};
export const WIX_MUSIC_TPA_ID = '13bb5d67-1add-e770-a71f-001277e17c57';
export const DEMO_ALBUM_ID = 'a6b72e_03a8f97fc6ed4f819fce2a1c8086211b';
export const NO_ALBUM_ID = '00000000-0000-0000-0000-000000000000';
